import _defineProperty from "/home/runner/work/aws-otel.github.io/aws-otel.github.io/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { cloneRequest } from "./cloneRequest";
export var moveHeadersToQuery = function moveHeadersToQuery(request) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _ref = typeof request.clone === "function" ? request.clone() : cloneRequest(request),
    headers = _ref.headers,
    _ref$query = _ref.query,
    query = _ref$query === void 0 ? {} : _ref$query;
  for (var _i = 0, _Object$keys = Object.keys(headers); _i < _Object$keys.length; _i++) {
    var _options$unhoistableH;
    var name = _Object$keys[_i];
    var lname = name.toLowerCase();
    if (lname.slice(0, 6) === "x-amz-" && !((_options$unhoistableH = options.unhoistableHeaders) !== null && _options$unhoistableH !== void 0 && _options$unhoistableH.has(lname))) {
      query[name] = headers[name];
      delete headers[name];
    }
  }
  return _objectSpread(_objectSpread({}, request), {}, {
    headers: headers,
    query: query
  });
};